import classNames from 'classnames';
import React from 'react';

import { useLocalization } from 'redux/localization/utils/hooks';

const Page = (props) => {
  const { page, isCurrent, onChange } = props;
  const { t } = useLocalization();

  const handleClick = () => {
    onChange(page);
  };

  return (
    <li className="c7-pagination__page">
      <button
        type="button"
        className={classNames('c7-link', isCurrent && 'c7-active')}
        onClick={handleClick}
      >
        <span className="c7-sr-only">{t('general.accessibility.page')}</span>
        {page}
      </button>
    </li>
  );
};

export default Page;
